const isKeyInResponse = (key = "") =>
  key === "username" ||
  key === "code" ||
  key === "refresh_token" ||
  key === "access_token" ||
  key === "id_token" ||
  key === "redirect_uri";

export const getParams = (searchParams) => {
  const response = {
    username: "",
    code: "",
    refresh_token: "",
    access_token: "",
    id_token: "",
    redirect_uri: "",
  };

  for (const [key, value] of searchParams) {
    if (isKeyInResponse(key)) response[key] = value;
  }

  return response;
};
